import React, { useState } from 'react';
import classNames from 'classnames';
import { Button } from 'primereact/button';
import moment from 'moment';
import { Dialog } from 'primereact/dialog';
import { useFormik } from 'formik';
import { InputText } from 'primereact/inputtext';
import { useDispatch } from 'react-redux';
import appActions from '../../../appActions';
import UserAutoCompleteInput from '../../../components/UserAutoCompleteInput';
import AvtarComponent from '../../../components/AvatarComponent';

const ChatList = (props) => {
    const {
        handleSelectedUser,
        selectedChat,
        connectionId,
        chatGroupList,
        ping,
    } = props;

    const handleSelectedChat = (chatItem) => {
        const { chatId, groupChat, chatUserName } = chatItem;
        handleSelectedUser({
            chatId: chatId,
            groupChat: groupChat,
            chatUserName: chatUserName,
        });
    };

    function truncateString(str, maxLength) {
        if (str.length <= maxLength) {
            return str;
        }
        return str.substring(0, maxLength - 3) + '...';
    }

    const getSender = (chat) => {
        const { userId } = chat;
        return userId ? `${userId}:` : '';
    };

    const formatMessageDate = (dateString) => {
        const date = moment(dateString, 'YYYY-MM-DD HH:mm:ss');
        const today = moment();

        if (date.isSame(today, 'day')) {
            return date.format('h:mm a'); // e.g., 2:10 pm
        } else {
            return date.format('DD/MM'); // e.g., 20/07
        }
    };

    return (
        <div className="chat-list child-sidebar">
            <ChatListHeader connectionId={connectionId} ping={ping} />
            {chatGroupList
                .sort((a, b) => new Date(b.msgTime) - new Date(a.msgTime))
                .map((chat, index) => {
                    // Ensure chatId is handled properly
                    let chatDisplayId;
                    
                    if (chat.chatId === null) {
                        chatDisplayId = 'Unknown User';
                    } else if (typeof chat.chatId === 'object') {
                        chatDisplayId = chat.chatId.label || chat.chatId.value || 'User Details';
                    } else if (typeof chat.chatUserName === 'string') {
                        chatDisplayId = chat.chatUserName;
                    } else if (typeof chat.chatId === 'string') {
                        chatDisplayId = chat.chatId;
                    } else {
                        chatDisplayId = 'Invalid Chat ID';
                    }

                    return (
                        <div
                            className={classNames({
                                'chat-list-item': true,
                                active: chat.chatId == selectedChat.chatId,
                            })}
                            key={index}
                            onClick={() => handleSelectedChat(chat)}
                        >
                            {chat && chat.chatId && (
                                <AvtarComponent username={chatDisplayId}/>
                            )}
    
                            <div className="chat-info w-full">
                                <div className="flex w-full">
                                    <div className="chat-name mr-4 mb-2">
                                        {chatDisplayId}
                                    </div>
                                    <div
                                        className="ml-auto"
                                        style={{ fontSize: '12px', width: '60px' }}
                                    >
                                        {formatMessageDate(chat.msgTime)}
                                    </div>
                                </div>
    
                                <div className="chat-last-message">
                                    {getSender(chat)}
                                    {truncateString(chat.message, 30)}
                                </div>
                            </div>
                        </div>
                        );
                }
                    
                   
                )}
        </div>
    );
};

const ChatListHeader = (props) => {
    const { connectionId, ping } = props;
    const [visible, setVisible] = useState(false);
    const handleGroupChat = () => {
        setVisible(true);
    };
    const closeDialog = () => {
        setVisible(false)
    }
    return (
        <div className="chat-header">
            <span className="chat-title">Chat</span>
            <div className="chat-icons">
                <i
                    className="pi pi-pen-to-square cursor-pointer"
                    style={{ fontSize: '1.5rem' }}
                    onClick={handleGroupChat}
                />
                {/* <i
                    className="pi pi-sync cursor-pointer"
                    style={{ fontSize: '1.5rem' }}
                    onClick={() => ping()}
                /> */}
            </div>
            <Dialog
                header="Create group chat"
                visible={visible}
                style={{ width: '50vw' }}
                onHide={() => {
                    if (!visible) return;
                    setVisible(false);
                }}
            >
                <GroupChatForm connectionId={connectionId} closeDialog={closeDialog} />
            </Dialog>
        </div>
    );
};

const GroupChatForm = (props) => {
    const dispatch = useDispatch();
    const { connectionId } = props;
    const [subscribers, setSubscribers] = useState([]);
    const formik = useFormik({
        initialValues: {
            title: '',
        },
        onSubmit: (values) => {
            const data = getFormattedPayload(values);
            createTopic(data)
        },
    });

    const createTopic = (data) => {
        dispatch(appActions.TOPIC_CREATE_REQUEST(data))
        props.closeDialog()
    }

    const getFormattedPayload = (values) => {
        const { title } = values;
        const topicId = formatTopicId(title);
        const data = {
            topicId: topicId,
            title: title,
            subscribers: formattedSubscribers(subscribers, topicId, title),
        };
        const currentSub = {
            topicId,
            userId: connectionId,
            title,
        };

        const foundSubscriber = data.subscribers.find(subscriber => 
            subscriber.userId.includes(connectionId));
        
        if(!foundSubscriber) {
            data.subscribers.push(currentSub);
        }
        return data;
    };

    const formattedSubscribers = (subscribers, topicId, title) => {
        if (subscribers.length > 0) {
            return subscribers.map((sub) => ({
                topicId,
                userId: sub.userId,
                title,
            }));
        }
        return [];
    };

    const handleSearchUser = (users) => {
        setSubscribers(users);
    };

    const getRandomFourDigitNumber = () => {
        return Math.floor(1000 + Math.random() * 9000);
    };

    const formatTopicId = (title) => {
        return `${connectionId}-${toKebabCase(title)}-${getRandomFourDigitNumber()}`;
    };

    const toKebabCase = (input) => {
        return input
            .toLowerCase()
            .trim()
            .replace(/[^a-z0-9]+/g, '-')
            .replace(/^-+|-+$/g, '');
    };

    return (
        <form onSubmit={formik.handleSubmit}>
            <div className="p-fluid formgrid grid w-full">
                <div className="field col-12">
                    <label htmlFor="title">Title</label>
                    <InputText
                        id="title"
                        name="title"
                        type="text"
                        value={formik.values.title}
                        onChange={formik.handleChange}
                    />
                </div>
                <div className="field col-12">
                    <label htmlFor="title">Add Users</label>
                    <UserAutoCompleteInput
                        handleSearchUser={handleSearchUser}
                        allowMultiple={true}
                    />
                </div>
            </div>
            <div>
                <Button
                    type="submit"
                    label="Create"
                    className="p-button mr-2"
                />
            </div>
        </form>
    );
};

export default ChatList;
